<div *ngIf="motMonths" class="year">
  <div
    class="month"
    [ngClass]="isTablet ? 'month--tablet' : 'month--desktop'"
    *ngFor="let month of motMonths; trackBy: trackByItems">
    <app-mot-month-view-annual-grid [isMomoUser]="isMomoUser" [month]="month"></app-mot-month-view-annual-grid>
  </div>
</div>
